import React, { useState } from 'react';
import { Button, Grid, TextField, Snackbar, CircularProgress, Typography } from '@mui/material';
import MuiAlert from '@mui/material/Alert';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import format from 'date-fns/format';
import zhTW from 'date-fns/locale/zh-TW';
import axios from 'axios';

const Alert = React.forwardRef((props, ref) => <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />);

const ServiceStatisticsDownload = () => {
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');
    const [isDownloading, setIsDownloading] = useState(false);
    const region = localStorage.getItem('region');

    const handleDownload = async () => {
        if (!startDate || !endDate) {
            setSnackbarMessage('請選擇開始和結束日期');
            setSnackbarSeverity('error');
            setOpenSnackbar(true);
            return;
        }

        setIsDownloading(true);

        try {
            const formattedStartDate = format(startDate, 'yyyy-MM-dd');
            const formattedEndDate = format(endDate, 'yyyy-MM-dd');

            const response = await axios.get(
                `https://api.smartbustw.com/api/line/statistics/download?startDate=${formattedStartDate}&endDate=${formattedEndDate}&region=${encodeURIComponent(region)}`,
                { responseType: 'blob' }
            );

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `服務統計數據_${formattedStartDate}_${formattedEndDate}.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.remove();

            setSnackbarMessage('下載成功');
            setSnackbarSeverity('success');
            setOpenSnackbar(true);
        } catch (error) {
            console.error('下載失敗', error);
            setSnackbarMessage('下載失敗，請稍後再試');
            setSnackbarSeverity('error');
            setOpenSnackbar(true);
        } finally {
            setIsDownloading(false);
        }
    };

    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={zhTW}>
            <Grid container spacing={2} alignItems="center">
                <Grid item xs={12}>
                    <Typography variant="h6" gutterBottom>
                        line@服務統計數據
                    </Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                    <DatePicker
                        label="開始日期"
                        value={startDate}
                        onChange={(newValue) => setStartDate(newValue)}
                        renderInput={(params) => <TextField {...params} fullWidth />}
                        inputFormat="dd/MM/yyyy"
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <DatePicker
                        label="結束日期"
                        value={endDate}
                        onChange={(newValue) => setEndDate(newValue)}
                        renderInput={(params) => <TextField {...params} fullWidth />}
                        inputFormat="dd/MM/yyyy"
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <Button
                        variant="contained"
                        onClick={handleDownload}
                        fullWidth
                        disabled={isDownloading}
                        startIcon={isDownloading ? <CircularProgress size={20} /> : null}
                        style={{ backgroundColor: '#4CAF50', color: 'white', height: '56px' }}
                    >
                        {isDownloading ? '下載中...' : '下載 Excel'}
                    </Button>
                </Grid>
            </Grid>
            <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleCloseSnackbar}>
                <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity} sx={{ width: '100%' }}>
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </LocalizationProvider>
    );
};

export default ServiceStatisticsDownload;